export default "__VITE_ASSET__DzjGcoXf__"